import { MemoizedSelector, MemoizedSelectorWithProps, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { LoaderError, RecommendationPanel } from '../../../model';
import { PyStateUtils } from '../../../state';
import { StateWithUser, UserState } from '../user-state';
import { getUserState } from './feature.selector';

export const getRecommendationPanelState: MemoizedSelector<
  StateWithUser,
  StateUtils.EntityLoaderState<RecommendationPanel>
> = createSelector(getUserState, (state: UserState) => state && state.recommendations);

export const getRecommendationPanel: MemoizedSelectorWithProps<StateWithUser, any, RecommendationPanel | undefined> =
  createSelector(
    getRecommendationPanelState,
    (state: StateUtils.EntityLoaderState<RecommendationPanel>, props) =>
      (!StateUtils.entityLoadingSelector(state, props.key) && StateUtils.entityValueSelector(state, props.key)) || undefined
  );

export const getRecommendationPanelStateLoading: MemoizedSelectorWithProps<StateWithUser, any, boolean> = createSelector(
  getRecommendationPanelState,
  (state: StateUtils.EntityLoaderState<RecommendationPanel>, props) => StateUtils.entityLoadingSelector(state, props.key)
);

export const getRecommendationPanelStateSuccess: MemoizedSelectorWithProps<StateWithUser, any, boolean> = createSelector(
  getRecommendationPanelState,
  (state: StateUtils.EntityLoaderState<RecommendationPanel>, props) => StateUtils.entitySuccessSelector(state, props.key)
);

export const getRecommendationPanelStateError: MemoizedSelectorWithProps<StateWithUser, any, LoaderError | undefined> =
  createSelector(getRecommendationPanelState, (state: StateUtils.EntityLoaderState<RecommendationPanel>, props) =>
    PyStateUtils.entityErrorDetailsSelector(state, props.key)
  );
